import type { IInnerHeaderComponent, IHeaderParams } from "ag-grid-enterprise";

/**
 * Pure truncation check AG Grid's own tooltipShowMode:"whenTruncated" uses
 * internally. Exposed standalone so the decision is unit-testable without
 * real layout.
 */
export function isOverflowing(
  clientWidth: number,
  scrollWidth: number
): boolean {
  return clientWidth < scrollWidth;
}

/**
 * Renders the header label and, when the column has a headerTooltip, gates
 * its visibility behind real DOM truncation via IHeaderParams.setTooltip —
 * independent of the grid-wide tooltipShowMode option (kept untouched here).
 */
export class HeaderLabelRenderer implements IInnerHeaderComponent {
  private eGui!: HTMLSpanElement;

  init(params: IHeaderParams): void {
    this.eGui = document.createElement("span");
    this.render(params);
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  refresh(params: IHeaderParams): boolean {
    this.render(params);
    return true;
  }

  private render(params: IHeaderParams): void {
    this.eGui.textContent = params.displayName;

    const headerTooltip = params.column.getColDef().headerTooltip;
    if (!headerTooltip) return;

    params.setTooltip(headerTooltip, () => this.isTruncated(params));
  }

  private isTruncated(params: IHeaderParams): boolean {
    const eText = params.eGridHeader.querySelector<HTMLElement>(
      ".ag-header-cell-text"
    );
    return eText ? isOverflowing(eText.clientWidth, eText.scrollWidth) : false;
  }
}
